import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data/brand";
import { AmbientLight } from "@/components/brand/AmbientLight";

export default function NotFound() {
  return (
    <main data-testid="notfound-page" className="min-h-screen relative flex items-center justify-center px-6 pt-32 bg-midnight-gradient overflow-hidden">
      <AmbientLight size={900} color="blue" intensity={0.4} style={{ top: "30%", left: "50%", transform: "translateX(-50%)" }} />
      <div className="relative text-center max-w-lg">
        <img src={BRAND.logoWhite} alt="" className="h-20 w-auto object-contain mx-auto opacity-50 mb-8" />
        <div className="font-mono text-[0.65rem] text-gold tracking-[0.28em] uppercase mb-6">ERROR / 404</div>
        <h1 className="font-display-tight text-5xl lg:text-6xl text-white mb-8 leading-[0.98] tracking-[-0.04em] font-light">
          Page <span className="gold-metallic font-display font-light">not found.</span>
        </h1>
        <p className="text-ag-text-secondary font-light leading-[1.65] mb-12">
          The page you are looking for is no longer available, or never existed.
        </p>
        <Link to="/" className="btn-gold inline-block">Return to the firm</Link>
      </div>
    </main>
  );
}
